import { render, staticRenderFns } from "./InvoicesVendors.vue?vue&type=template&id=fbb59d70&"
import script from "./InvoicesVendors.vue?vue&type=script&lang=js&"
export * from "./InvoicesVendors.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesVendors.vue?vue&type=style&index=0&id=fbb59d70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports